import React from 'react'
import styled from 'styled-components/macro'

import { ColorsMap, FontSizeMap, FontWeightMap } from '@/utils/Theme'

import { Catalog, GalleryLink } from '@/types/Content'

type BrandDescriptionProps = {
  brand: string
  items: Catalog[] | GalleryLink[]
}

const BrandCatalogues = ({ brand, items }: BrandDescriptionProps) => {
  if (items.length === 0) {
    return null
  }

  return (
    <Wrapper>
      {items && (
        <Items>
          {items.map((item) => (
            <Item href={item.link} target="_blank" download={item.download}>
              <ItemImage src={item.imgSrc} />
              <ItemTitleWrapper>
                <ItemTitle dangerouslySetInnerHTML={{ __html: item.title }}></ItemTitle>
              </ItemTitleWrapper>
            </Item>
          ))}
        </Items>
      )}
    </Wrapper>
  )
}

export default BrandCatalogues

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2rem 0;
`

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  column-gap: 2rem;
  row-gap: 2rem;
`

const Item = styled.a`
  max-width: 18rem;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //border: 1px solid;
  background-color: white;
  float: left;
  text-decoration: none;
  color: unset;
`

const ItemImage = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1.41;
  object-fit: cover;
  background-color: ${ColorsMap.primary};
`

const ItemTitleWrapper = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
`

const ItemTitle = styled.div`
  color: ${ColorsMap.primary};
  font-size: ${FontSizeMap.m};
  font-weight: ${FontWeightMap.bold};
  text-align: center;
`
